export interface SeasonalData {
    title: string;
    text: string;
}

declare global {
	interface Window { seasonalData: any; }
}


const init = async () => {
	// Handle Mobile Nav Toggles
    const mobileToggle = document.querySelector(".mobile-nav-toggle");
    const mobileClose = document.querySelector(".mobile-nav-close");
    const navLinkWrapper = document.querySelector(".nav-body");
    const navLinks = navLinkWrapper?.querySelectorAll("a");

    navLinks?.forEach((link) => {
        link.addEventListener("click", () => {
            navLinkWrapper?.classList.remove("show");
        })
    })

    mobileClose?.addEventListener("click", () => {
        navLinkWrapper?.classList.remove("show");
    });

    mobileToggle?.addEventListener("click", () => {
        document.querySelector(".nav-body")?.classList.add("show");
    });

    // *** NAV DROPDOWN ***//
    const navDropdowns = document.querySelectorAll(".nav-dropdown");

    // Detect if the device supports touch (to prevent hover conflicts)
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

    navDropdowns.forEach((navDropdown) => {
        const dropdownToggle = navDropdown.querySelector(".dropdown-toggle");

        if (!isTouchDevice) {
            // Open on hover (desktop only)
            navDropdown.addEventListener("mouseenter", () => {
                navDropdown.classList.add("open");
            });

            navDropdown.addEventListener("mouseleave", () => {
                navDropdown.classList.remove("open");
            });
        }

        // Open/close on click (for touch devices & hybrid screens)
        dropdownToggle?.addEventListener("click", (event) => {
            event.preventDefault(); // Prevents unintended link behavior

            // Close all other dropdowns before toggling the clicked one
            navDropdowns.forEach((dropdown) => {
                if (dropdown !== navDropdown) {
                    dropdown.classList.remove("open");
                }
            });

            // Toggle the clicked dropdown
            navDropdown.classList.toggle("open");
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener("click", (event) => {
        const target = event.target as HTMLElement | null;

        // If the clicked element is NOT inside a dropdown, close all dropdowns
        if (!target?.closest(".nav-dropdown")) {
            navDropdowns.forEach((dropdown) => dropdown.classList.remove("open"));
        }
    });
    // *** END NAV DROPDOWN ***//

    // Handle Hero Animations, handling the hero section separately from the rest of the page (to esure it runs no matter what, not relying on the observer)
    const hero = document.querySelector(".hero-animation");
    if (hero) {
        const textToAnimate = hero.querySelectorAll("h1, p");
        textToAnimate.forEach((el, index) => {
            const element = el as HTMLElement;

            // Remove and re-add animation to force Safari to recognize it
            element.style.animation = "none"; // Reset animation
            void element.offsetWidth; // Force reflow
            element.style.animation = `slideUp 1s ease ${index * 0.5}s forwards`;
        });
    }


    //Handle any other animations that need to occur when scrolling through the page
    const fadeInScroll = () => {
        const intersectionObserver = (el) => {
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if(entry.isIntersecting){
                        const cards = el.querySelectorAll(".card");
                        cards.forEach((card, index) => {
                            (card as HTMLElement).style.animation = `slideUp 1s ease ${index * 0.5}s forwards`;
                        })
                        el.classList.add("is-visible");
                    }
                })
            });
            observer.observe(el)
        }
        document.querySelectorAll(".colored-cards").forEach((el) => {
            intersectionObserver(el);
        })
    }
    fadeInScroll();

    //Handle FAQs
    const handleFaqs = (init = false) => {
        const faqs = document.querySelectorAll(".faq");
      
        faqs.forEach((faq) => {
          faq?.querySelector(".answer")?.setAttribute("style",`max-height: auto; visibility: hidden;`);
      
          const contentHeight = faq?.querySelector(".answer")?.clientHeight;
            
          if(contentHeight){
            faq?.querySelector(".answer")?.setAttribute("style",`--faq-max-height: ${contentHeight + 24}px; max-height: 0px;`);
          }
      
          if(init){
              const faqButton = faq.querySelector(".question");
              faqButton?.addEventListener("click", () => {
                faqs.forEach((x) => {
                    if(x === faq){
                        return;
                    }
                    x.classList.remove("active");
                })
                faq.classList.toggle("active");
              });
          }
        });
    };
    handleFaqs(true);
    window.addEventListener("resize", () => {
        handleFaqs();
    });


    // Handle custom form select
    const customFormSelect = document.querySelector(".form-select-dropdown .select-dropdown") as HTMLElement;
    const selectedOption = customFormSelect?.querySelector(".selected") as HTMLElement;
    const dropdownOptions = customFormSelect?.querySelectorAll(".dropdown-option button");
    const formInput = document.querySelector("#reason-for-contact") as HTMLInputElement;
    const errorMsg = document.querySelector(".error-msg") as HTMLElement;
    const form = document.querySelector(".contact-form") as HTMLFormElement;

    selectedOption?.addEventListener("click", () => {
        customFormSelect?.classList.toggle("open");
    })

    dropdownOptions?.forEach((option) => {
        option.addEventListener("click", () => {
            const value = option.getAttribute("data-value");
            if(selectedOption && value){ 
                const span = selectedOption.querySelector("span");
                if (span) {
                    span.innerHTML = value;
                }
            }

            if(formInput && value) {
                formInput.value = value;
            }

            if(value && value !== "Select One"){
                errorMsg?.classList.remove("show");
            }

            customFormSelect?.classList.remove("open");
        })
    })

    if(form){
        form.onsubmit = (e) => {
            if(formInput && (formInput.value === "Select One" || !formInput.value.trim().length || !formInput.value)){
                e.preventDefault();
                errorMsg?.classList.add("show");
            }
        }
    }   

    //Handle home page links
    const url = new URL(window.location.href);
    const linkhash = url.hash;
    if(linkhash){
        const target = document.querySelector(linkhash);
        if(target){
            target.scrollIntoView();
        }
    }

   //*** HERO NAV ***//
    (function() {
        const heroSlider = document.querySelector('.hero-slider') as HTMLElement;
        const prevButton = document.querySelector('.slider-btn.prev') as HTMLButtonElement;
        const nextButton = document.querySelector('.slider-btn.next') as HTMLButtonElement;

        if (!heroSlider || !prevButton || !nextButton) {
            return;
        }

        let currentIndex = 0;
        let slides: NodeListOf<HTMLElement>;

        nextButton.addEventListener('click', function () {
            currentIndex = (currentIndex + 1) % slides.length;
            updateHeroNavSlider();
        });

        prevButton.addEventListener('click', function () {
            currentIndex = (currentIndex - 1 + slides.length) % slides.length;
            updateHeroNavSlider();
        });

        //Excludes current page from the mobile slider
        function updateHeroNavSlides() {
            slides = document.querySelectorAll('.hero-slide:not(.current-page)');
        }

        //Handles sliding of hero nav items
        function updateHeroNavSlider() {
            updateHeroNavSlides();
            heroSlider.style.transform = `translateX(-${currentIndex * 100}%)`;
            updateArrowButtonStates();
        }

        //Handles enabling/disabling arrow buttons
        function updateArrowButtonStates() {
            if (currentIndex === 0) {
                prevButton.disabled = true;
                prevButton.setAttribute('aria-disabled', 'true');
            } else {
                prevButton.disabled = false;
                prevButton.setAttribute('aria-disabled', 'false');
            }

            if (currentIndex === slides.length - 1) {
                nextButton.disabled = true;
                nextButton.setAttribute('aria-disabled', 'true');
            } else {
                nextButton.disabled = false;
                nextButton.setAttribute('aria-disabled', 'false');
            }
        }

        updateHeroNavSlider();
    })();
    //*** END HERO NAV ***//

    //*** SEASONAL CALLOUT ***//
    //Store the text data for each season
	
    
    const seasonButtons = document.querySelectorAll<HTMLButtonElement>(".seasonal-features-callout .button-wrap button");
    const images = document.querySelectorAll<HTMLImageElement>(".seasonal-features-callout .img-wrap img");
    const title = document.querySelector<HTMLHeadingElement>(".seasonal-features-callout .text-wrap h2");
    const text = document.querySelector<HTMLParagraphElement>(".seasonal-features-callout .text-wrap p");
    const activitySections = document.querySelectorAll<HTMLElement>(".seasonal-activities-sect");
    
    seasonButtons.forEach((seasonButton) => {
        seasonButton.addEventListener("click", function () {
             //Get the data associated with the season that was clicked
            const season = this.dataset.season;
    
            if (season) {
                const seasonDataObj = window.seasonalData[season];
    
                if (seasonDataObj) {

                    //Update text
                    if (title && text) {
                        title.textContent = seasonDataObj.title;
                        text.textContent = seasonDataObj.text;
                    }

                    //REmove active class from all buttons and img
                    images.forEach((img) => img.classList.remove("active"));
                    seasonButtons.forEach((btn) => btn.classList.remove("active"));

                    //Add active state to active img
                    images.forEach((img) => {
                        if (img.dataset.season === season) {
                            img.classList.add("active");
                        }
                    });

                    //Move focus to active img
                    const activeImage = document.getElementById(`${season}-img`);
                    if (activeImage) {
                        activeImage.focus();
                    }

                    //Manage aria-selected attribute on season buttons
                    seasonButtons.forEach((btn) => {
                        btn.setAttribute("aria-selected", btn === this ? "true" : "false");
                    });

                    // Show/hide activity sections below
                    activitySections.forEach((seasonSection) => {
                        seasonSection.classList.toggle("active", seasonSection.dataset.season === season);
                    });
                }
            }
            //Add active state to active season button
            if (!this.classList.contains("active")) {
                this.classList.add("active");
            }
        });
    });
    //*** END SEASONAL CALLOUT ***//
};


export default async () => {
	if (globalThis.usingTemplateLoader)
		addEventListener('templateLoaded', init);
	else {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
              init();
            });
          } else {
            init();
          }
	}
};
